import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Layout from "../components/Layout";
import { Card, CardHeader, CardContent } from "../components/ui/Card";
import { Button } from "../components/ui/Button";
import api from "../services/api";
import EditAssetModal from "../components/assets/EditAssetModal";

const AssetDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [asset, setAsset] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isEditOpen, setIsEditOpen] = useState(false);

  const fetchAsset = async () => {
    try {
      setLoading(true);
      const res = await api.get(`/assets/${id}`);
      setAsset(res.data);
    } catch (e) {
      console.error("Erro ao buscar ativo:", e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAsset();
  }, [id]);

  const handleEditSubmit = (formData) => {
    if (!asset?.id) return;

    const payload = {
      asset_type: formData.asset_type,
      brand: formData.brand,
      model: formData.model,
      hostname: formData.hostname,
      serial_number: formData.serial_number,
      patrimony_code: formData.patrimony_code,
      invoice_number: formData.invoice_number,
      status: formData.status,
      location: formData.location,
      collaborator_id: formData.collaborator_id ? Number(formData.collaborator_id) : null,
      notes: formData.notes,
    };

    setIsEditOpen(false);

    api
      .put(`/assets/${asset.id}`, payload)
      .then(() => fetchAsset())
      .catch((error) => {
        console.error("Erro ao atualizar ativo:", error);
        alert("Erro ao atualizar ativo.");
      });
  };

  const handleDelete = (assetId) => {
    setIsEditOpen(false);

    api
      .delete(`/assets/${assetId}`)
      .then(() => navigate("/assets"))
      .catch((error) => {
        console.error("Erro ao deletar ativo:", error);
        alert("Erro ao deletar ativo.");
      });
  };

  const field = (label, value) => (
    <div className="py-2">
      <div className="text-xs text-gray-500">{label}</div>
      <div className="text-sm text-gray-900">{value || "—"}</div>
    </div>
  );

  return (
    <Layout>
      <div className="space-y-6">
        <div className="flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
          <div>
            <Button variant="link" onClick={() => navigate("/assets")} className="h-auto p-0 text-gray-600">
              ← Voltar
            </Button>
            <h1 className="text-2xl font-bold text-gray-900 mt-1">Detalhes do Ativo</h1>
          </div>

          <Button onClick={() => setIsEditOpen(true)} disabled={!asset}>
            Editar
          </Button>
        </div>

        <Card>
          <CardHeader>
            <div>
              <h2 className="text-lg font-semibold text-gray-900">Ativo #{id}</h2>
              <p className="text-sm text-gray-500">Informações individuais do equipamento</p>
            </div>
          </CardHeader>

          <CardContent>
            {loading ? (
              <div className="text-center py-8 text-gray-500">Carregando...</div>
            ) : !asset ? (
              <div className="text-center py-8 text-gray-500">Ativo não encontrado</div>
            ) : (
              <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                {field("Tipo", asset.asset_type || asset.type)}
                {field("Status", asset.status)}
                {field("Marca", asset.brand)}
                {field("Modelo", asset.model)}
                {field("Hostname", asset.hostname)}
                {field("Número de Série", asset.serial_number)}
                {field("Código Patrimonial", asset.patrimony_code)}
                {field("Nota Fiscal", asset.invoice_number)}
                {field("Colaborador vinculado", asset.collaborator_name)}
                {field("Localização", asset.location)}
                {field("Observações", asset.notes || asset.observations)}
              </div>
            )}
          </CardContent>
        </Card>

        <EditAssetModal
          isOpen={isEditOpen}
          onClose={() => setIsEditOpen(false)}
          asset={asset}
          onSubmit={handleEditSubmit}
          onDelete={handleDelete}
        />
      </div>
    </Layout>
  );
};

export default AssetDetails;
